class MobileNav extends React.Component {

    render() {
        return (
            <div className='mobile-nav'>
                <ul>
                    <li id='mobile-nav-hero' className='mobile-nav__current'><a className='smoothscroll' href='#hero'>Home.</a></li>
                    <li id='mobile-nav-portfolio'><a className='smoothscroll' href='#portfolio'>Works.</a></li>
                    <li id='mobile-nav-services'><a className='smoothscroll' href='#services'>Services.</a></li>
                    <li id='mobile-nav-about'><a className='smoothscroll' href='#about'>About.</a></li>
                    <li id='mobile-nav-team'><a className='smoothscroll' href='#team'>Team.</a></li>
                    <li id='mobile-nav-contact'><a className='smoothscroll' href='#contact'>Contact.</a></li>
                </ul>
            </div>
        );
    }
}

export default MobileNav;



// WEBPACK FOOTER //
// ./ui_src/app/components/header/MobileNav.react.jsx